import { parseGameKey } from 'config-hub-server/src/model/keys.js';

/**
 * How a record is named on screen: name first, id second. This is the only place that decides it.
 *
 * - With a name, `label` is the name and `secondary` the id (monospace, dimmed).
 * - With no name, a blank one, or one equal to the id, `label` is the id alone and `labelIsId` is
 *   true, so it renders in monospace.
 *
 * A child's key is `<parentKey>/<id>`; the id shown is its own leaf (`big-bass`), never the key.
 * The leaf is what `parseGameKey` reads after the FIRST separator — the same split every other
 * reader of a key makes — and a key with no leaf (a studio's) is shown whole.
 */
export type RowLabel = { label: string; secondary: string | null; labelIsId: boolean };

export const leafId = (key: string): string => parseGameKey(key)?.id || key;

export const rowLabel = (title: string | null | undefined, key: string): RowLabel => {
    const id = leafId(key);
    const name = typeof title === 'string' ? title.trim() : '';
    if (!name || name === id) return { label: id, secondary: null, labelIsId: true };
    return { label: name, secondary: id, labelIsId: false };
};
